// Importing code libraries for this block
import { __ } from '@wordpress/i18n';
import { registerBlockType } from '@wordpress/blocks';
import { 
	RichText,
	PlainText
	 } from '@wordpress/block-editor';

import { Button } from '@wordpress/components';



/**
 * Editor styles.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
//import './editor.scss';

/**
 * Edit function.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

export default function edit( {
	className,
	attributes,
	setAttributes
} ) {

const {shortcode} = attributes;

	const set_gutenberg_Attrs = (  ) => {
		window.ptl_gutenberg_attrs = {
					className,
					attributes,
					setAttributes
				};
	};  
    return(

    	<div className="ptl-shortcode-block">

			<Button
				tagName="strong"
				className='components-button is-secondary ptl-shortcode-button'
				data-toggle="modal"
				data-target="#insert-ptl-shortcode"
				id="ptl-shortcode-insert"
				onClick = { set_gutenberg_Attrs }
			>Add Shortcode</Button>
			<RichText
				tagName='div'

				placeholder= '[post-timeline template="0" ]'
				className= 'input-control blocks-shortcode-textarea ptl_shortcode_area'
				value= {shortcode}
				onChange = { (value) => setAttributes({shortcode:value }) }
			/>
    	</div>
    );
}